export class InvalidInputError extends Error {
    public errors: any[];

    /**
     */
    constructor(errors: any[], ...params: any) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Custom debugging information
        this.errors = errors;
    }
}
